import { ErrorReporterArgumentType } from "./error-reporter-argument-type";

export interface IErrorReporter {
	log(...args: ErrorReporterArgumentType[]): void;
	debug(...args: ErrorReporterArgumentType[]): void;
	info(...args: ErrorReporterArgumentType[]): void;
	warn(...args: ErrorReporterArgumentType[]): void;
	error(...args: ErrorReporterArgumentType[]): void;
	critical(...args: ErrorReporterArgumentType[]): void;
}
